import { LvfVehicleStructureType } from '../../../enum/supplychain/lvf-vehicle-structure-type';

export interface IEquipmentVehicleTypeExtensionInfo {
  LvfVehicleStructureType?: LvfVehicleStructureType;
  HasEngine?: boolean;
  HasRemorque?: boolean;
  HasFret?: boolean;
  HasCoveredFret?: boolean;
  HasColdgroup?: boolean;
  HasCarFretExtension?: boolean;
  CanAttachRemorque?: boolean;
  IsSemiRemorque?: boolean;
  IsVL?: boolean;
  CoefPonderation?: number;
  NbOfSeats?: number;
}

export class EquipmentVehicleTypeExtension {
  LvfVehicleStructureType?: LvfVehicleStructureType;
  HasEngine?: boolean;
  HasRemorque?: boolean;
  HasFret?: boolean;
  HasCoveredFret?: boolean;
  HasColdgroup?: boolean;
  HasCarFretExtension?: boolean;
  CanAttachRemorque?: boolean;
  IsSemiRemorque?: boolean;
  IsVL?: boolean;
  CoefPonderation?: number;
  NbOfSeats?: number;

  constructor(info: IEquipmentVehicleTypeExtensionInfo) {
    this.LvfVehicleStructureType = info.LvfVehicleStructureType;
    this.HasEngine = info.HasEngine;
    this.HasRemorque = info.HasRemorque;
    this.HasFret = info.HasFret;
    this.HasCoveredFret = info.HasCoveredFret;
    this.HasColdgroup = info.HasColdgroup;
    this.HasCarFretExtension = info.HasCarFretExtension;
    this.CanAttachRemorque = info.CanAttachRemorque;
    this.IsSemiRemorque = info.IsSemiRemorque;
    this.IsVL = info.IsVL;
    this.CoefPonderation = info.CoefPonderation;
    this.NbOfSeats = info.NbOfSeats;
  }
}
